import _ from 'lodash';
import { Modal } from "antd";
import { useSelector } from "react-redux";
import styles from "./recBox.module.scss";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { Dropdown, Menu, Tooltip, Input, Select } from "antd";
import React, {useEffect, useState } from "react";
import { URInput } from "../../../../../shared/widgets/input";
import { URCheckBox } from "../../../../../shared/widgets/checkbox";
import { DeleteRecordings, recordedTranscript} from "../../../../../base/callService/callsApiService";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import VoiceMailAudioInner from "../../voiceMailAudioInner";
import {
  asrSearchLanguage,
  downloadURL,
  getlanguageName,
  languageChange,
  shareFileWithMsg, timeStampConverter,
  toastInformation, userStatusColor
} from "../../../../../base/callService/common";
//import { ChatService } from "../../../../../base/chatService";
import { callMainPageInterface, closeCaptionmeetingState } from "../../../../../models/callModel";
import store from "../../../../../context/store/store";
import WaveFormVoicemail from "../../playerWaveForm/WaveFormAudio";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import { update_Voice_Spec_Language } from "../../../../../base/callService/store_mining";
import MemberLists from '../../memberList';
import { initialStateModel } from '../../../../../models/model';

type RecBoxState = {
  isModalDelete: boolean;
  isModalShare:boolean;
  allContacts:Array<any>;
  tempAllContacts:Array<any>;
  chooseParticipants: Array<any>;
  deleteID: any;
  errorWave: boolean;
  asr_Search: string;
  isVisibleLanguage: boolean;
  searchText: string;
  description: string;
}

export default function RecBox() {
  const [getRecBox, setRecBox] = useState<RecBoxState>({
    isModalDelete: false, isModalShare:false,allContacts:[],tempAllContacts:[],
    chooseParticipants: [], deleteID:[], errorWave:false,asr_Search:'',isVisibleLanguage:false ,searchText:'',description:''});
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  
  let { callReducer}: initialStateModel = useSelector((state: initialStateModel) => state);

  let {particularLog } = callReducer;

  let { isModalShare,isModalDelete,allContacts,tempAllContacts,chooseParticipants,deleteID} = getRecBox;
  let { rightSideWindow } = store.getState().updatedCallList;
  let workList = contactReducer.workContacts;
  let teamList:Array<any> = contactReducer.teamContacs;
  let searchableContact: Array<any> = workList.concat(teamList);

  useEffect(() => {
    errorwave(false);
  }, [particularLog]);
  

  const textBoxOnchange = (keyPress: any) => {
    setRecBox({ ...getRecBox, asr_Search: keyPress.target.value });
  };
  const updateOutputLanguage = (lanChar: string) => {
    update_Voice_Spec_Language(lanChar);
    setRecBox({ ...getRecBox, isVisibleLanguage: false });
    languageChange();
  };

  const handle_VisibleChange = (flag: boolean) => {
    setRecBox({ ...getRecBox, isVisibleLanguage:flag});
  };

  let ASR_Data: any = store.getState().ASR_Language || [];
  let ast_defaultOpt = ASR_Data.voice_speaker_lan || 'en';
  let asrLanguage = asrSearchLanguage(ASR_Data.list, getRecBox.asr_Search);
  let speakerLang: any = getlanguageName(ASR_Data.list, ast_defaultOpt) || [];
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];

  const outPutLangSelection = (
    <>
      <div className={styles.autoTranslateLangs}>
        <span className={styles.topsecTxtTitle}>Record Spoken language</span>
        <div className={styles.searchBox}><URInput placeHolder='Search' className='searchBoxlanglist'
          onChange={textBoxOnchange} /></div>
        <ul className={`scroller ${styles.langList}`}>
          {asrLanguage.map((elem: any, index: number) => {
            return (<li key={index} className={ast_defaultOpt === elem.languageCode?`${styles.selected } ${styles.active }` :styles.selected}
              onClick={() => updateOutputLanguage(elem.languageCode)}>
              <span className={ast_defaultOpt === elem.languageCode?`icon_tick  ltick`:'icon_tick'}></span>
              {elem.languageName + " (" + elem.languageCode + ")"}</li>);
          })
          }
        </ul>
        <div className={`customchecksize ${styles.bottomFooterSec}`}>
          <URCheckBox /><span className={styles.saveTxttop}>Save for future</span>
        </div>
      </div>
    </>
  );
  
  const openShare = () => {
    setRecBox({ ...getRecBox, isModalShare:true, allContacts:searchableContact,tempAllContacts:searchableContact});
  };

  const selectSingle = (id: any) => {
    let data = [];
    data.push(id);
    setRecBox({
      ...getRecBox, deleteID: data,isModalDelete: true
    });
  };
  const confirmShare = () => {
    if (chooseParticipants.length < 1 ) return toastInformation("No contacts selected", "warning");
 
    let sendData:any= {
      fileName:  'Recorded call',
      fileType :'mp3',
      filesize : '2mb',
       filePath: particularLog?.recordingUrl,
       text : getRecBox.description
  }
    shareFileWithMsg(getRecBox.chooseParticipants, sendData);
    handleCancelShare();
    toastInformation("Recording Shared successfully", 'success');
  };
 
  const handleCancelShare =()=>{
    setRecBox({...getRecBox,chooseParticipants:[],description:'',allContacts:[],searchText:'',isModalShare:false});
  };
  const closeModals = () => {
    setRecBox({ ...getRecBox, isModalShare: false,isModalDelete:false});
  };
  
  const confirmDelete = () => {
    DeleteRecordings(deleteID);
    setRecBox({ ...getRecBox,isModalDelete:false,deleteID:[]});
  };

  const searchContact = _.debounce(async(e: any) => {
    let searchName = e.toLowerCase();
    if(searchName !== "") {
      let filtered= _.filter(tempAllContacts, function(name:any) {
        return  name.caller_id?.toLowerCase().includes(searchName) ||
        name.ext?.toString().includes(searchName) || name.team_name?.toLowerCase().includes(searchName);
      });
      setRecBox({...getRecBox,allContacts:filtered,searchText:searchName});
    }
    else{
      if(searchName === "") {
        setRecBox({...getRecBox,allContacts:tempAllContacts,searchText:''});
      }
    }
    
  }, 500);

  const change = (val:any,obj:any) =>{
    setRecBox({...getRecBox,chooseParticipants:val,
      allContacts:searchableContact});
  };
  const menu = (
    <Menu>
      <Menu.Item onClick={openShare}>Share</Menu.Item>
      <Menu.Item onClick={()=>selectSingle(particularLog?.uuid)}>Delete</Menu.Item>
      <Menu.Item onClick={()=>downloadURL(particularLog?.recordingUrl)}>Download</Menu.Item>
    </Menu>
  );
  const errorwave = (data: boolean) => {
    setRecBox({ ...getRecBox, errorWave: data });
  };

  const addDescription = (e: any) => {
    setRecBox({ ...getRecBox, description: e.target.value });
  }
  return (
    <>
      <div className={`callfadein ${styles.voicemailBox}`}>
        {/* {speakerLang.languageCode !== 'en' &&
        <div className={styles.outputLang}>
          <label>Output</label>
          {asrLanguage.map((elem: any, index: number) => {
            return (<span key={index} onClick={() => updateOutputLanguage(elem.languageCode)}>
              {elem.languageName}</span>);
          })}
        </div>
        } */}
        <div className={styles.audioSec}>
          {getRecBox.errorWave ?
            <VoiceMailAudioInner particularLog={particularLog} />
            :
            <WaveFormVoicemail errorwave={errorwave}/>
          }
        </div>
        <div className={getRecBox.errorWave ? `${styles.voiceMailOptions} pointerevents` : styles.voiceMailOptions}>
          
          <Tooltip placement="top" title={(rightSideWindow === "summary" && closeCaption.asrCallingFrom === 'recordList')?"Automated Minutes OFF":"Automated Minutes ON"}
          ><div onClick={() => recordedTranscript(particularLog.uuid, 'summary')}
            className={(rightSideWindow === "summary" && closeCaption.asrCallingFrom === 'recordList') ?
            `${styles.active} ${styles.autoMatedMinutes}` : `${styles.autoMatedMinutes}`} >
          </div></Tooltip>
          
          <Tooltip placement="top" title={(rightSideWindow === "transcript" && closeCaption.asrCallingFrom === 'recordList')?"Transcribe OFF":"Transcribe ON"}>
            <div onClick={() => recordedTranscript(particularLog.uuid,'transcript')}
              className={(rightSideWindow === "transcript" && closeCaption.asrCallingFrom === 'recordList') ?
              `${styles.active} ${styles.transcribe}` : `${styles.transcribe}`}></div></Tooltip>
          <Tooltip placement="top" title="Audio Translation OFF"><div className={styles.autoTranslate}>
            <div className={`${styles.translateSec}`}>
              <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}
                onVisibleChange={handle_VisibleChange}
                visible={getRecBox.isVisibleLanguage}>
                <div className={styles.langSelSec}>
                  <span className="icon_down-arrow" onClick={() => handle_VisibleChange(true)}>
                    
                  </span>
                </div>
              </Dropdown>
            </div>
            {speakerLang.languageCode !== 'en' &&
              <div className={styles.inputLang}>{ speakerLang.languageName }</div>
            }
          </div></Tooltip>
          <Tooltip placement="top" title="More">
            <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
              <div className={`moreactive ${styles.moreAction}`}></div>
            </Dropdown>
          </Tooltip>
        </div>
      </div>
      {(ast_defaultOpt !== 'en' && closeCaption.voiceDataStore.voiceCaptionText !== '') &&
        <div className={styles.langTextMain}>
          <div className={styles.langText}>
            {closeCaption.voiceDataStore.voiceCaptionText}
          </div>
        </div>
      }
      <Modal title="Delete  selected call recodrings?"
        centered
        visible={isModalDelete}
        onOk={confirmDelete}
        onCancel={closeModals}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
           Are you sure want to delete the selected recordings?
      </Modal>
  
  
      <Modal visible={isModalShare} title="Share this Recorded Call"
        centered
        onOk={confirmShare}
        onCancel={handleCancelShare}
        cancelText="Cancel"
        okText="Share"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup borderbdm">
        <div className={styles.shareSelect}>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
           /*  optionLabelProp="label" */
            filterOption={false}
            showSearch={true}
            value={getRecBox.chooseParticipants}
           // defaultValue={getRecBox.chooseParticipants}
            onSearch={searchContact}
            placeholder="Search name or extension"
            className="newselects"
            onChange={change}
          >
          {MemberLists(getRecBox.searchText , allContacts)}

          </Select>
        </div>
        <div className="txtareaDes">
          <Input.TextArea title="Add a message, if you'd like." placeholder="Add a message, if you'd like."
           onChange={(e)=>addDescription(e)}/>
        </div>
        {/* <div className="lftImfseccont">
                <img src={users} alt=""/>
                <p><span>Harry.png</span><span>File size: 365KB</span></p>
            </div> */}
  
        <div className={`audiofile ${styles.audioAttachList}`}>
          <div className={styles.shareaudiofile}>
            <span className={styles.avright}> <URAvatarGroup className='lefts size32'
              profileInfo={
                (particularLog?.ImageURL !== "" &&  particularLog?.ImageURL!== null) ?
                  (<>
                    <img src={particularLog?.ImageURL} alt="" />
                    <URStatusDot className={userStatusColor(particularLog?.user_status, 'small')} />
                  </>) :
                  (<>
                    <span>{particularLog?.caller_id?.charAt(0).toUpperCase()} </span>
                    {<URStatusDot className={ userStatusColor(particularLog?.user_status,'small')} />}
                  </>)
              } />
            </span>
          </div>
          <div className="audioNew audioAttachment">
            <p className={styles.audiotitle}>{particularLog?.caller_id}
              {timeStampConverter(particularLog?.created_at,'middle')} Record</p>
            <AudioPlayer
              src={particularLog?.recordingUrl}
              customIcons={{
                play: <span className="icon_play"></span>,
                pause: <span className="icon_sendarrow"></span>
              }}
              customProgressBarSection={
                [
                  RHAP_UI.MAIN_CONTROLS,
                  RHAP_UI.PROGRESS_BAR,
                  RHAP_UI.DURATION
                        
                ]
              }
              customControlsSection={
                []
              }
              autoPlay={false}
            />
            <p className={styles.audiofile}><span>Audio</span><span>{particularLog?.recording_duration}
              {particularLog?.recordingUrl?.substring(particularLog?.recordingUrl?.lastIndexOf('.') + 1)}
            </span></p>
          </div>
          <div className={styles.hoverClick}>
            <Tooltip placement="top" title={'Remove File'}>
              <span className="icon_close"></span>
            </Tooltip>
          </div>
          {/* <div className={styles.loadingIcon}>
                    <object data={file_loader} type="image/svg+xml">Loading...</object>
                </div> */}
        </div>
      </Modal>
    </>
  );
};
  